import {IconBookingStatusPlus} from "./svg-icons/IconBookingStatusPlus.tsx";
import {IconBookingStatusCheck} from "./svg-icons/IconBookingStatusCheck.tsx";
import {IconBookingStatusInfoOrange} from "./svg-icons/IconBookingStatusInfoOrange.tsx";
import {IconBookingStatusError} from "./svg-icons/IconBookingStatusError.tsx";
import {IconBookingStatusBlue} from "./svg-icons/IconBookingStatusBlue.tsx";
import "../styles/components/Availability.css"
import {AvailabilityProps} from "../types/travel.ts"

export function Availability({
        type = 1
    }: AvailabilityProps) {

    const getIcon = (type: number) => {
        if(type === 1) return <IconBookingStatusPlus />
        if(type === 2) return <IconBookingStatusCheck />
        if(type === 3) return <IconBookingStatusInfoOrange />
        if(type === 4) return <IconBookingStatusError />
        if(type === 5) return <IconBookingStatusBlue />
        return <IconBookingStatusBlue />;
    }

    const getText = (type: number) => {
        if (type === 1) return "Buchbar";
        if (type === 2) return "Gesichert";
        if (type === 3) return "Wenig Plätze";
        if (type === 4) return "Ausgebucht";
        if (type === 5) return "Angekündigt";
        return "";
    }

    return (
        <div className="availability">
            <span className="icon">
                {getIcon(type)}
            </span>
            <span className="text">{getText(type)}</span>
        </div>
    )
}
